import { gql } from '@urql/core';

const APP_DEFINITION_FIELDS = gql`
  fragment AppDefinitionFields on AppDefinition {
    id
    code
    category
    type
    configSchema
    iconUrl
    features
    coverageCountries
    developerName
    documentationUrl
    pricingModel
    tags
    name
    description
    shortDescription
    isPublished
    sortOrder
    translations {
      id
      languageCode
      name
      description
      shortDescription
      configLabels
      setupGuide
    }
  }
`;

const APP_INSTALLATION_FIELDS = gql`
  fragment AppInstallationFields on AppInstallation {
    id
    isEnabled
    config
    installedAt
    lastConfiguredAt
    appDefinition {
      ...AppDefinitionFields
    }
  }
  ${APP_DEFINITION_FIELDS}
`;

export const GET_APP_DEFINITIONS = gql`
  query GetAppDefinitions($category: String) {
    appDefinitions(category: $category) {
      ...AppDefinitionFields
    }
  }
  ${APP_DEFINITION_FIELDS}
`;

export const GET_APP_CENTER_CAPABILITIES = gql`
  query GetAppCenterCapabilities {
    appCenterCapabilities {
      merchantAppCenter
    }
  }
`;

export const GET_APP_INSTALLATIONS = gql`
  query GetAppInstallations {
    appInstallations {
      ...AppInstallationFields
    }
  }
  ${APP_INSTALLATION_FIELDS}
`;

export const GET_APP_INSTALLATION = gql`
  query GetAppInstallation($appCode: String!) {
    appInstallation(appCode: $appCode) {
      ...AppInstallationFields
    }
  }
  ${APP_INSTALLATION_FIELDS}
`;

export const INSTALL_APP = gql`
  mutation InstallApp($appCode: String!, $config: JSON) {
    installApp(appCode: $appCode, config: $config) {
      ...AppInstallationFields
    }
  }
  ${APP_INSTALLATION_FIELDS}
`;

export const UNINSTALL_APP = gql`
  mutation UninstallApp($appCode: String!) {
    uninstallApp(appCode: $appCode)
  }
`;

export const UPDATE_APP_CONFIG = gql`
  mutation UpdateAppConfig($appCode: String!, $config: JSON!) {
    updateAppConfig(appCode: $appCode, config: $config) {
      ...AppInstallationFields
    }
  }
  ${APP_INSTALLATION_FIELDS}
`;

export const TOGGLE_APP = gql`
  mutation ToggleApp($appCode: String!, $enabled: Boolean!) {
    toggleApp(appCode: $appCode, enabled: $enabled) {
      ...AppInstallationFields
    }
  }
  ${APP_INSTALLATION_FIELDS}
`;

export const TEST_CAPI_CONNECTION = gql`
  mutation TestCapiConnection($appCode: String!) {
    testCapiConnection(appCode: $appCode) {
      success
      error
    }
  }
`;

export const TEST_APP_CONNECTION = gql`
  mutation TestAppConnection($appCode: String!, $config: JSON!) {
    testAppConnection(appCode: $appCode, config: $config) {
      valid
      error
    }
  }
`;
